
import React from 'react';
import CityMetauxPage from '@/components/valorisation/CityMetauxPage';

const AchatMetauxAlbi = () => {
  return (
    <CityMetauxPage
      cityName="Albi"
      departmentName="Tarn"
      departmentCode="81"
      region="Occitanie"
      description="Préfecture du Tarn et ville d'art et d'histoire, Albi bénéficie de notre expertise dans le rachat de métaux issus du patrimoine architectural et de l'industrie locale."
      specialities={[
        "Métaux du patrimoine historique",
        "Cuivre et plomb de toitures anciennes",
        "Ferraille de restauration architecturale",
        "Métaux industriels et artisanaux"
      ]}
      nearbyAreas={[
        "Carmaux", "Gaillac", "Cordes-sur-Ciel", "Lescure-d'Albigeois", "Saint-Juéry", "Arthès"
      ]}
      heroImage="https://images.unsplash.com/photo-1466442929976-97f336a657be?w=1280&q=80"
    />
  );
};

export default AchatMetauxAlbi;
